function onDomLoaded(callback) {
  if (document.readyState !== 'loading') {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback);
  }
}

function onElementLoaded(selector, callback) {
  let element;
  let elementLoadedTimer = setInterval(() => {
    element = document.querySelector(selector);
    if (element) {
      clearInterval(elementLoadedTimer);
      elementLoadedTimer = null;
      callback(element);
    }
  }, 50);

  setTimeout(() => {
    if (elementLoadedTimer) {
      clearInterval(elementLoadedTimer);
      elementLoadedTimer = null;
    }
  }, 10000);
}

export { onDomLoaded, onElementLoaded };
